import React from 'react';

import LazyLoadedImage from 'common/LazyLoadedImage';
import Stack from 'common/ui/Stack';
import { P } from 'common/ui/Text';
import styles from 'css-module/components/subdomain/admin/v2/_AdminV2ErrorView.module.scss';

import PurpleIcon from 'img/canny-icon.svg';

const AdminV2ErrorView = () => {
  return (
    <Stack className={styles.errorView} alignment="center" justify="center" spacing="md">
      <LazyLoadedImage alt="Canny logo" className={styles.logo} src={PurpleIcon} />
      <P variant="bodyMd" color="red90">
        Something went wrong. Try reloading the page. If the issue persists, please{' '}
        <a
          className={styles.link}
          href="mailto:support@canny.io"
          target="_blank"
          rel="noreferrer noopener">
          contact support
        </a>{' '}
        for assistance.
      </P>
    </Stack>
  );
};

export default AdminV2ErrorView;
